import css from 'styled-jsx/css';

const staticStyles = css`
  .ChangeDocumentTypeModal {
    width: 450px;

    &__current {
      margin-bottom: 20px;
      font-size: 14px;
      color: #666;
    }

    &__field {
      margin-bottom: 20px;
    }

    &__buttons {
      display: flex;
      gap: 15px;

      :global(.DefaultButton) {
        flex: 1;
      }
    }
  }
`;

export default staticStyles;
